var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.question.isReadOnlyRenderDiv() && _vm.question.getMaxLength()
    ? _c(
        "div",
        [
          _c("sv-text-area", { attrs: { model: _vm.question.textAreaModel } }),
          _vm._v(" "),
          _c("sv-character-counter", {
            attrs: {
              counter: _vm.question.characterCounter,
              remainingCharacterCounter:
                _vm.question.cssClasses.remainingCharacterCounter,
            },
          }),
        ],
        1
      )
    : !_vm.question.isReadOnlyRenderDiv()
    ? _c("sv-text-area", { attrs: { model: _vm.question.textAreaModel } })
    : _c("div", [_vm._v(_vm._s(_vm.question.value))])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }